import Parse from 'parse'

const MAXIMUM_VERSIONS_LOADED = 1000

const compareByVersion = (first, second) =>
  Number(first.get('version')) - Number(second.get('version'))

const loadAllVersionsOfOrders = async (orderCodes) => {
  const query = new Parse.Query('ConsolidatedOrder')
  query.containedIn('order_code', orderCodes)
  query.limit(MAXIMUM_VERSIONS_LOADED)
  return query.find()
}

const groupVersionsByOrderCode = (consolidatedOrders) => {
  const versionsByOrderCode = {}
  consolidatedOrders.forEach((consolidatedOrder) => {
    const orderCode = consolidatedOrder.get('order_code')
    versionsByOrderCode[orderCode] = [...(versionsByOrderCode[orderCode] || []), consolidatedOrder]
  })
  Object.keys(versionsByOrderCode).forEach((orderCode) => {
    versionsByOrderCode[orderCode].sort(compareByVersion)
  })
  return versionsByOrderCode
}

const buildLatestVersionWithHistory = (versions) => {
  const latestVersion = versions[versions.length - 1]
  latestVersion.set(
    'all_versions',
    [...versions].reverse().map((version) => ({ ...version.toJSON(), key: version.id }))
  )
  return latestVersion
}

export const groupConsolidatedOrdersByOrder = async (consolidatedOrders) => {
  const orderCodes = [
    ...new Set(consolidatedOrders.map((item) => item.get('order_code')).filter(Boolean)),
  ]
  if (!orderCodes.length) return consolidatedOrders

  const versionsByOrderCode = groupVersionsByOrderCode(await loadAllVersionsOfOrders(orderCodes))
  const alreadyGroupedOrderCodes = new Set()

  return consolidatedOrders.reduce((groupedRows, item) => {
    const orderCode = item.get('order_code')
    if (!orderCode) return [...groupedRows, item]
    if (alreadyGroupedOrderCodes.has(orderCode)) return groupedRows

    alreadyGroupedOrderCodes.add(orderCode)
    const versions = versionsByOrderCode[orderCode] || [item]
    return [...groupedRows, buildLatestVersionWithHistory(versions)]
  }, [])
}
